export interface SuperAdminProfileLike {
  is_super_admin?: boolean | null;
}

export function hasSuperAdminAccess(profile?: SuperAdminProfileLike | null) {
  return profile?.is_super_admin === true;
}
